import { render, staticRenderFns } from "./Nomad.vue?vue&type=template&id=12379787&"
import script from "./Nomad.vue?vue&type=script&lang=js&"
export * from "./Nomad.vue?vue&type=script&lang=js&"
import style0 from "./Nomad.vue?vue&type=style&index=0&id=12379787&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports